// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"c9736954","384":"c9736954"}[chunkId] + ".chunk.css";
};